import React__default, { useContext } from 'react';
import Modal from '../../ui/Modal.js';
import { a as ButtonTypes } from '../../index-41a6f4f2.js';
import { a as LocalizationContext } from '../../LocalizationContext-b021af8f.js';
import { u as useChannel } from '../../ChannelProvider-d5126903.js';
import 'prop-types';
import 'react-dom';
import '../../index-1fd114b0.js';
import '../../ui/IconButton.js';
import '../../_rollupPluginBabelHelpers-8e4fae98.js';
import '../../ui/Icon.js';
import '../../index-a611bd38.js';
import '../../stringSet-91746bf1.js';
import '../../utils-9ef11656.js';
import '../../index-353f13f3.js';
import '../../UserProfileContext-daa99f9b.js';
import '../../useSendbirdStateContext.js';
import '../../withSendBird.js';
import '../../index-4a59a866.js';
import '../../topics-17d99dd6.js';
import '../../index-ad4c9e58.js';
import '../../tslib.es6-83aa13f5.js';
import '../../compareIds-48d87cc5.js';
import '../../const-3f63e129.js';
import '../../uuid-6d14d007.js';
import '../../ui/ContextMenu.js';
import '../../ui/SortByRow.js';
import '../../ui/ReactionButton.js';
import '../../ui/ImageRenderer.js';

var RemoveMessage = function RemoveMessage(props) {
  var _a;

  var onCancel = props.onCancel,
      message = props.message;
  var stringSet = useContext(LocalizationContext).stringSet;
  var deleteMessage = useChannel().deleteMessage;
  return /*#__PURE__*/React__default.createElement(Modal, {
    type: ButtonTypes.DANGER,
    disabled: ((_a = message === null || message === void 0 ? void 0 : message.threadInfo) === null || _a === void 0 ? void 0 : _a.replyCount) > 0,
    onCancel: onCancel,
    onSubmit: function onSubmit() {
      deleteMessage(message).then(function () {
        onCancel();
      });
    },
    submitText: stringSet.MESSAGE_MENU__DELETE,
    titleText: stringSet.MODAL__DELETE_MESSAGE__TITLE
  });
};

export { RemoveMessage as default };